import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import loanFormModel from '../../form_models/loanFormModel';
import { Rule } from '../../interfaces/Rule';

const { applicantSameAsPrincipal } = loanFormModel.formField;

class IsApplicantSameAsPrincipal implements Rule {
  private principalId: any;

  public setPrincipalId(id: any) {
    this.principalId = id;
    return this;
  }

  private getPrincipal(data: Partial<ApplicationFormValues>) {
    return data.principals?.find(
      (principal) => principal.id === this.principalId
    );
  }

  public evaluate(application: Partial<ApplicationFormValues>): boolean {
    const principal = this.getPrincipal(application);

    const applicantSameAsPrincipalValue =
      principal?.[applicantSameAsPrincipal.name] === 'Yes';
    return applicantSameAsPrincipalValue ?? false;
  }
}

export default new IsApplicantSameAsPrincipal();
